import angular from 'angular';

export const templatesModule = angular.module(
  'portainer.edge.react.views.templates',
  []
).name;
